// extracted by mini-css-extract-plugin
module.exports = {"response":"OneWord_response__2JLcP","block":"OneWord_block__11G4N","answer2":"OneWord_answer2__2oi9c"};